<!-- adminHome -->
<template>
    <div class='admin-home'>
		<div class="but">
			<el-button size="mini" type="primary" @click="() => {$router.push('/projectlist')}">{{$t('btns.list')}}</el-button>
		</div>
		
        <div :style="{height:'100%',width:'100%'}" ref="myEchart"></div>
    </div>
</template>

<script>
import echarts from "echarts";
// import 'echarts/map/js/world.js'
import 'echarts/map/js/china.js' // 引入中国地图数据
import "echarts/extension/bmap/bmap.js"
import Service from '@/api/Service'
import Storage from '@/utils/storage'

export default {
    name:  'AdminHome',
    data() {
        return {
            chart: null,
            projectList: [],
        };
    },
    mounted() {
        
    },
    beforeDestroy() {
        if (!this.chart) {
            return;
        }
        this.chart.dispose();
        this.chart = null;
    },

    created() {
        this.getData()
    },
    computed: {},

    methods: {
        async getData() {
            let res = await Service.getProjectList({
                project_name: '',
                province: '',
                city: '',
                dist: '',
                project_principal_name: '',
                page_num: 1,
                page_sum: 100
            });
            if(res) {
                let data = res.list === null ? [] : res.list;
                this.projectList = data;
                this.chinaConfigure();
            }
        },
        chinaConfigure() {
            let _t = this;
            let myChart = echarts.init(this.$refs.myEchart); //这里是为了获得容器所在位置    
            window.onresize = myChart.resize;
            myChart.setOption({ // 进行相关配置
                title: {
                    text: '项目总览',
                    left: 'center'
                },
                tooltip : {
                    trigger: 'item',
                    formatter: function(data) {
                        let str = `项目名称：${data.data.name}<br/>物业名称：${data.data.property}<br/>负责人：${data.data.project_principal_name}`
                        return str
                    },
                },
                bmap: {
                    center: [104.114129, 37.550339],
                    zoom: 5,
                    roam: true,
                    mapStyle: {
                        styleJson: [{
                            'featureType': 'water',
                            'elementType': 'all',
                            'stylers': {
                                'color': '#d1d1d1'
                            }
                        }, {
                            'featureType': 'land',
                            'elementType': 'all',
                            'stylers': {
                                'color': '#f3f3f3'
                            }
                        }, {
                            'featureType': 'railway',
                            'elementType': 'all',
                            'stylers': {
                                'visibility': 'off'
                            }
                        }, {
                            'featureType': 'highway',
                            'elementType': 'all',
                            'stylers': {
                                'color': '#fdfdfd'
                            }
                        }, {
                            'featureType': 'highway',
                            'elementType': 'labels',
                            'stylers': {
                                'visibility': 'off'
                            }
                        }, {
                            'featureType': 'arterial',
                            'elementType': 'geometry',
                            'stylers': {
                                'color': '#fefefe'
                            }
                        }, {
                            'featureType': 'arterial',
                            'elementType': 'geometry.fill',
                            'stylers': {
                                'color': '#fefefe'
                            }
                        }, {
                            'featureType': 'poi',
                            'elementType': 'all',
                            'stylers': {
                                'visibility': 'off'
                            }
                        }, {
                            'featureType': 'green',
                            'elementType': 'all',
                            'stylers': {
                                'visibility': 'off'
                            }
                        }, {
                            'featureType': 'subway',
                            'elementType': 'all',
                            'stylers': {
                                'visibility': 'off'
                            }
                        }, {
                            'featureType': 'manmade',
                            'elementType': 'all',
                            'stylers': {
                                'color': '#d1d1d1'
                            }
                        }, {
                            'featureType': 'local',
                            'elementType': 'all',
                            'stylers': {
                                'color': '#d1d1d1'
                            }
                        }, {
                            'featureType': 'arterial',
                            'elementType': 'labels',
                            'stylers': {
                                'visibility': 'off'
                            }
                        }, {
                            'featureType': 'boundary',
                            'elementType': 'all',
                            'stylers': {
                                'color': '#fefefe'
                            }
                        }, {
                            'featureType': 'building',
                            'elementType': 'all',
                            'stylers': {
                                'color': '#d1d1d1'
                            }
                        }, {
                            'featureType': 'label',
                            'elementType': 'labels.text.fill',
                            'stylers': {
                                'color': '#999999'
                            }
                        }]
                    }
                },
                series: [
                    {
                        name: '',
                        type: 'effectScatter',
                        coordinateSystem: 'bmap',
                        data: _t.fmtData(),
                        symbolSize: function (val) {
                            return val[2];
                        },
                        showEffectOn: 'render',
                        rippleEffect: {
                            brushType: 'stroke'
                        },
                        label: {
                            normal: {
                                formatter: '{b}',
                                position: 'right',
                                show: false
                            },
                        },
                        itemStyle: {
                            normal: {
                                color: 'purple',
                                shadowBlur: 10,
                                shadowColor: '#333'
                            }
                        }
                    },
                ],
            })
            myChart.on('click',{seriesType: "effectScatter"}, function (params) {
                _t.goPreject(params.data)
            });
        },
        goPreject(v){
            // 设置项目ID
            Storage.set('PROJECT_OID',{project_oid:v.oid});
            Storage.set('ProjectInfo',{projectInfo:v.projectInfo});     //  本地缓存项目信息，减少OID获取项目信息次数
            // if(v.projectInfo.sysid === 1) {
            //     // 机房系统
            //     this.$router.push({ path: "/machinemana/0" });
            // }else{
            //     // 群控系统+计费系统
            //     this.$router.push({ path: "/home" });
            // }
			this.$router.push({ path: "/projectsystemlist" });
        },
        fmtData(){
            let res = [];
            let size = 10;
            this.projectList.map(v=>{
                res.push({
                    name: v.project_name,
                    value: [v.longitude, v.latitude, size],
                    project_principal_name: v.project_principal_name,
                    property: v.property,
                    oid: v.oid,
                    projectInfo: v,
                });
            })
            return res;
        }
    }
}

</script>
<style lang='less' scoped>
    .admin-home{
        height: 100%;
		position: relative;
    }
	.but{
		width: 100px;
		position: absolute;
		top: -39px;
		right:56px;
	}
</style>